import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '@/plugins/api.js'
import bvToast from '@/plugins/bvToast.js'
import BootstrapVue3 from 'bootstrap-vue-3'
import swipeDirective from './directives/swipe.js'

// Quill CSS
import 'quill/dist/quill.snow.css'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import * as bootstrap from 'bootstrap'
window.bootstrap = bootstrap

const app = createApp(App)
app.use(router)
app.use(BootstrapVue3)
app.use(bvToast)
app.directive('swipe', swipeDirective)
app.mount('#app')
